
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BackIcon } from '@components/overview-dashboard/common/Icons';
import { isEditableFlagSelector } from '@store/overviewDashboard/spiThresholds/selectors';
import { AdminIcon, SPIHeaderTitle, ErrorMessage } from '../styled';
import { onClickOfBackButtonInAdminHeader } from '../helper';
import AdminIcons from './AdminIcons';
import { OVERVIEW_LABELS } from '@src/utils/kpi';

const AdminHeader = ({
  config, selectedKPIConfig, isEditable, selectedKPIConfigID, closeEditPopup, isSPIPopupOpen,
}) => {
  const dispatch = useDispatch();
  const [isDropdown, showDropDown] = useState(true);
  const isBeingEdited = useSelector(isEditableFlagSelector);
  const [isCreateNewError, setCreateNewError] = useState(false);

  useEffect(() => {
    setCreateNewError(false);
  }, [selectedKPIConfig, isBeingEdited, isSPIPopupOpen]);

  const toggleCreateNewError = () => {
    setCreateNewError(!isCreateNewError);
  };

  const onClickOfBackButton = () => {
    onClickOfBackButtonInAdminHeader(config, selectedKPIConfigID, dispatch, showDropDown);
  };

  const getTitle = () => (
    <SPIHeaderTitle>
      {(isBeingEdited) ? 'Enter KPI name' : 'Select KPI'}
      {(isBeingEdited) ? (<AdminIcon onClick={onClickOfBackButton}><BackIcon /></AdminIcon>) : null}
    </SPIHeaderTitle>
  );

  return (
    <>
      {getTitle()}
      <AdminIcons
        config={config}
        selectedKPIConfig={selectedKPIConfig}
        isEditable={isEditable}
        selectedKPIConfigID={selectedKPIConfigID}
        closeEditPopup={closeEditPopup}
        setCreateNewError={setCreateNewError}
      />
      {isCreateNewError ? <ErrorMessage onClick={toggleCreateNewError}>{OVERVIEW_LABELS.ERROR_CREATE_NEW}</ErrorMessage> : null}
    </>
  );
};

export default AdminHeader;
